import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useFamiliesChartsDataContext } from './hooks/useFamiliesChartsDataContext';

export const Indicators = () => {
    const { chartData } = useFamiliesChartsDataContext();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Card
                title="Total de Famílias Cadastradas"
                value={number.formatToBRNumber(
                    chartData?.indicators?.familiesRegistered || 0
                )}
            />
            <Card
                title="Total de Pessoas Cadastradas"
                value={number.formatToBRNumber(
                    chartData?.indicators?.peopleRegistered || 0
                )}
            />
            <Card
                title="Média de Pessoas por Família"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averagePeoplePerFamily || 0
                )}
            />
        </div>
    );
};
